import { render } from "./End.vue?vue&type=template&id=38d342f0&scoped=true"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import "./End.vue?vue&type=style&index=0&id=38d342f0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d342f0"]])

export default __exports__